import React, { useEffect } from "react";
 
 
const SiteHome = (props) => {
   
   
   

 return (
    <div>
      <hr />
      
      <figure className="figure p-4 m-5">
           
         <h1> Wellcome to my test page (ReactJs)  </h1>  
         
      </figure>
    </div> 
  );
};
export default SiteHome;
